<template>
  <div>
    <div class="tournaments__wrapper">
      <skelet-rectangle :width="500" :height="40" />
      <skelet-rectangle :width="200" :height="40" />
    </div>
    <skelet-rectangle :width="1500" :height="150" v-for="item in 10" :key="item" />
  </div>
</template>


<script>
import SkeletRectangle from "@/views/sceleton/components/rectangle";

export default {
  name: "tournaments-skeleton",
  components: {SkeletRectangle},
}
</script>

<style lang="scss" scoped>
  .rect {
    margin-bottom: 4px;
  }
</style>
